import api from "./api";

class AnnouncementService {
    list() {
        return api.get("/api/announcements/");
    }
    listArchived() {
        return api.get("/api/announcements/?show_archived=true");
    }
    get(id) {
        return api.get(`/api/announcements/${id}/`);
    }
    create(data) {
        return api.post("/api/announcements/", data);
    }
    update(id, data) {
        return api.patch(`/api/announcements/${id}/`, data);
    }
    delete(id) {
        return api.delete(`/api/announcements/${id}/hard-delete/`);
    }
    archive(id) {
        return api.delete(`/api/announcements/${id}/`);
    }
    unarchive(id) {
        return api.post(`/api/announcements/${id}/unarchive/`);
    }
    unreadCount() {
        return api.get("/api/announcements/unread-count/");
    }
    markRead(id) {
        return api.post(`/api/announcements/${id}/mark-read/`);
    }
    markAllRead() {
        return api.post("/api/announcements/mark-all-read/");
    }

    // ── Attachments (DropBox) ────────────────────────────────────────────────

    uploadDocument(file) {
        const formData = new FormData();
        formData.append("document", file);
        formData.append("title", file.name);
        return api.post("/api/announcements/dropbox/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    deleteDocument(id) {
        return api.delete(`/api/announcements/dropbox/${id}/`);
    }
}

export default new AnnouncementService();
